import React, { useEffect, useState } from 'react';

export const useNotificacion = () => {
  const [notif, setNotif] = useState(null);
  const mostrarNotif = (datos) => setNotif(datos);
  return { notif, mostrarNotif };
};

const CFG = {
  error:             { color: '#ef4444', glow: 'rgba(239,68,68,0.4)',   icono: '✗', tituloDefault: 'Algo falta' },
  warning:           { color: '#f59e0b', glow: 'rgba(245,158,11,0.4)',  icono: '⚠', tituloDefault: 'Atención' },
  success:           { color: '#22c55e', glow: 'rgba(34,197,94,0.4)',   icono: '✓', tituloDefault: '¡Listo!' },
  info:              { color: '#00f2ff', glow: 'rgba(0,242,255,0.4)',   icono: 'ℹ', tituloDefault: 'Info' },
  jugada_preparada:  { color: '#c4b5fd', glow: 'rgba(124,58,237,0.5)', icono: '🕶️', tituloDefault: '¡Jugada Preparada!' },
  medalla:           { color: '#f59e0b', glow: 'rgba(245,158,11,0.4)', icono: '🏅', tituloDefault: '¡Nuevo hito!' },
};

// ── Toast (esquina inferior derecha, no bloquea la pantalla) ─────────────────
export const ToastJugadaPreparada = ({ emoji, nombre, onCerrar }) => {
  const [saliendo, setSaliendo] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => { setSaliendo(true); setTimeout(onCerrar, 400); }, 5000);
    return () => clearTimeout(t);
  }, []); // eslint-disable-line

  return (
    <>
      <style>{`
        @keyframes toast-in  { from{opacity:0;transform:translateX(80px)} to{opacity:1;transform:translateX(0)} }
        @keyframes toast-out { from{opacity:1;transform:translateX(0)}    to{opacity:0;transform:translateX(80px)} }
      `}</style>
      <div style={{
        position: 'fixed', bottom: '24px', right: '24px', zIndex: 99999,
        background: 'linear-gradient(135deg, #0f0a1a 0%, #0a0618 100%)',
        border: '1px solid #7c3aed88',
        borderRadius: '14px', padding: '14px 18px',
        display: 'flex', alignItems: 'center', gap: '12px',
        boxShadow: '0 0 30px rgba(124,58,237,0.35), 0 4px 20px rgba(0,0,0,0.5)',
        maxWidth: '320px', cursor: 'pointer',
        animation: `${saliendo ? 'toast-out' : 'toast-in'} 0.4s cubic-bezier(.22,.68,0,1.2) forwards`,
      }} onClick={() => { setSaliendo(true); setTimeout(onCerrar, 400); }}>
        {/* Línea superior */}
        <div style={{ position: 'absolute', top: 0, left: '10%', right: '10%', height: '1px', background: 'linear-gradient(90deg,transparent,#a855f7,transparent)', borderRadius: '99px' }} />
        <span style={{ fontSize: '1.6rem', flexShrink: 0 }}>{emoji}</span>
        <div>
          <p style={{ color: '#c4b5fd', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 2px', fontWeight: 'bold' }}>Jugada Preparada</p>
          <p style={{ color: '#e2e8f0', fontSize: '0.88rem', fontWeight: 'bold', margin: 0 }}>{nombre}</p>
          <p style={{ color: '#6d28d9', fontSize: '0.7rem', margin: '2px 0 0' }}>Medalla oculta desbloqueada</p>
        </div>
      </div>
    </>
  );
};

// ── Toast genérico para medallas/hitos ───────────────────────────────────────
export const ToastMedalla = ({ emoji, nombre, onCerrar }) => {
  const [saliendo, setSaliendo] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => { setSaliendo(true); setTimeout(onCerrar, 400); }, 4000);
    return () => clearTimeout(t);
  }, []); // eslint-disable-line

  return (
    <>
      <style>{`
        @keyframes toast-medalla-in  { from{opacity:0;transform:translateX(80px)} to{opacity:1;transform:translateX(0)} }
        @keyframes toast-medalla-out { from{opacity:1;transform:translateX(0)}    to{opacity:0;transform:translateX(80px)} }
      `}</style>
      <div style={{
        position: 'fixed', bottom: '24px', right: '24px', zIndex: 99999,
        background: 'linear-gradient(135deg, #0a0f19 0%, #080d14 100%)',
        border: '1px solid #f59e0b66',
        borderRadius: '14px', padding: '14px 18px',
        display: 'flex', alignItems: 'center', gap: '12px',
        boxShadow: '0 0 24px rgba(245,158,11,0.25), 0 4px 20px rgba(0,0,0,0.5)',
        maxWidth: '320px', cursor: 'pointer',
        animation: `${saliendo ? 'toast-medalla-out' : 'toast-medalla-in'} 0.4s cubic-bezier(.22,.68,0,1.2) forwards`,
      }} onClick={() => { setSaliendo(true); setTimeout(onCerrar, 400); }}>
        <div style={{ position: 'absolute', top: 0, left: '10%', right: '10%', height: '1px', background: 'linear-gradient(90deg,transparent,#f59e0b,transparent)', borderRadius: '99px' }} />
        <span style={{ fontSize: '1.6rem', flexShrink: 0 }}>{emoji}</span>
        <div>
          <p style={{ color: '#f59e0b', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 2px', fontWeight: 'bold' }}>🏅 Nuevo hito</p>
          <p style={{ color: '#e2e8f0', fontSize: '0.88rem', fontWeight: 'bold', margin: 0 }}>{nombre}</p>
        </div>
      </div>
    </>
  );
};

const Notificacion = ({ tipo = 'error', titulo, mensaje, onCerrar, autoClose = 0 }) => {
  const [saliendo, setSaliendo] = useState(false);
  const cfg = CFG[tipo] || CFG.error;
  const tituloFinal = titulo || cfg.tituloDefault;
  const mensajes = Array.isArray(mensaje) ? mensaje : [mensaje];

  const cerrar = () => { setSaliendo(true); setTimeout(onCerrar, 260); };

  useEffect(() => {
    if (autoClose > 0) { const t = setTimeout(cerrar, autoClose); return () => clearTimeout(t); }
  }, []); // eslint-disable-line

  if (!mensaje) return null;

  return (
    <>
      <style>{`
        @keyframes nf-bg-in  { from{opacity:0} to{opacity:1} }
        @keyframes nf-bg-out { from{opacity:1} to{opacity:0} }
        @keyframes nf-in  { from{opacity:0;transform:translateY(20px) scale(.95)} to{opacity:1;transform:translateY(0) scale(1)} }
        @keyframes nf-out { from{opacity:1;transform:translateY(0) scale(1)} to{opacity:0;transform:translateY(10px) scale(.97)} }
      `}</style>
      <div onClick={(e)=>{ if(e.target===e.currentTarget) cerrar(); }} style={{
        position:'fixed',inset:0,background:'rgba(0,0,0,0.72)',backdropFilter:'blur(7px)',
        zIndex:99999,display:'flex',alignItems:'center',justifyContent:'center',
        animation:`${saliendo?'nf-bg-out':'nf-bg-in'} 0.26s ease forwards`,
      }}>
        <div style={{
          background:'linear-gradient(160deg,#0d1527 0%,#080f1c 100%)',
          border:`1.5px solid ${cfg.color}`,borderRadius:'20px',
          padding:'36px 40px 30px',maxWidth:'400px',width:'88vw',
          boxShadow:`0 0 0 1px ${cfg.color}22,0 0 40px ${cfg.glow},0 0 80px ${cfg.glow}55`,
          position:'relative',textAlign:'center',
          animation:`${saliendo?'nf-out':'nf-in'} 0.26s cubic-bezier(.22,.68,0,1.2) forwards`,
        }}>
          <div style={{position:'absolute',top:0,left:'15%',right:'15%',height:'2px',background:`linear-gradient(90deg,transparent,${cfg.color},transparent)`,borderRadius:'99px'}}/>
          <button onClick={cerrar} style={{position:'absolute',top:'13px',right:'15px',background:'none',border:'none',color:'#334155',fontSize:'1rem',cursor:'pointer',lineHeight:1,transition:'color .15s'}}
            onMouseEnter={e=>e.currentTarget.style.color='#64748b'} onMouseLeave={e=>e.currentTarget.style.color='#334155'}>✕</button>
          <div style={{width:'54px',height:'54px',borderRadius:'50%',background:`${cfg.color}14`,border:`1.5px solid ${cfg.color}55`,display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 18px',fontSize:'1.5rem',color:cfg.color,boxShadow:`0 0 20px ${cfg.glow}`}}>{cfg.icono}</div>
          <h3 style={{color:cfg.color,margin:'0 0 12px',fontSize:'1.1rem',fontWeight:800,letterSpacing:'0.4px',textShadow:`0 0 14px ${cfg.glow}`}}>{tituloFinal}</h3>
          <div style={{color:'#94a3b8',fontSize:'0.87rem',lineHeight:1.65}}>
            {mensajes.length===1
              ? <p style={{margin:0}}>{mensajes[0]}</p>
              : <ul style={{margin:0,padding:0,listStyle:'none',display:'flex',flexDirection:'column',gap:'5px',textAlign:'left'}}>
                  {mensajes.map((m,i)=>(
                    <li key={i} style={{display:'flex',gap:'8px',alignItems:'flex-start'}}>
                      <span style={{color:cfg.color,flexShrink:0,marginTop:'3px',fontSize:'0.6rem'}}>◆</span>
                      <span>{m}</span>
                    </li>
                  ))}
                </ul>
            }
          </div>
          <button onClick={cerrar} style={{marginTop:'24px',padding:'9px 34px',background:`${cfg.color}16`,border:`1px solid ${cfg.color}77`,borderRadius:'50px',color:cfg.color,fontWeight:700,fontSize:'0.84rem',cursor:'pointer',letterSpacing:'0.4px',transition:'all .18s'}}
            onMouseEnter={e=>{e.currentTarget.style.background=`${cfg.color}28`;e.currentTarget.style.boxShadow=`0 0 16px ${cfg.glow}`;}}
            onMouseLeave={e=>{e.currentTarget.style.background=`${cfg.color}16`;e.currentTarget.style.boxShadow='none';}}>Entendido</button>
          <div style={{position:'absolute',bottom:0,left:'20%',right:'20%',height:'1px',background:`linear-gradient(90deg,transparent,${cfg.color}44,transparent)`}}/>
        </div>
      </div>
    </>
  );
};

export default Notificacion;